/**
 * @(#)2019/8/06.
 * Modal 参数构建
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

/**
 *
 *
 * @returns
 */
export default function () {
  return {};
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxModal/Drawer/param.js